import React from 'react';
import { useSelector } from 'react-redux';
import CallInComingPhoneIcon from 'src/assets/icons/CallIncomingPhoneIcon';
import WaitingScreenIcon from 'src/assets/icons/WaitingScreenIcon';
import { RootState } from 'src/store';
import styles from './CallIncomingPopup.module.scss';
import ErrorIcon from 'src/assets/icons/Error';
import image from '../../../assets/images/error-boundary.svg';
import { H3 } from '@primitives/Typography/Typography.stories';
import Typography from '@primitives/Typography/Typography';
import AlertOutlineIcon from '@icons/AlertOutlineIcon/AlertOutlineIcon';
import { ameyoErroneousCallWaitingScreenText } from './dc97Constant';
import { Countdown } from '../../../components/Countdown/Countdown';
import AlertIcon from '@icons/AlertIcon/AlertIcon';
import cx from 'classnames';
import InfoIcon from '@icons/InfoIcon/InfoIcon';
import debounce from '@utils/Debounce';
import { addClickstreamEvent } from '../../../service/clickStreamEventService';
import { HRC_CLICKSTREAM, HRC_EVENTS } from '../../../service/clickStream.constant';
import { ExtensionHandler } from '../../../utils/extension.utils';

interface CallIncomingPopupProps {
  showCallIncomingPopup: boolean;
  showAuthBlockedPopup: boolean;
  showMultipleCampaignsPopup: boolean;
  onCallAcceptHandler: () => void;
  onCallRejectHandler: () => void;
  focusAmeyoHandler: () => void;
}

const CallWaitingScreen = (props: CallIncomingPopupProps) => {
  const {
    showCallIncomingPopup,
    showAuthBlockedPopup,
    showMultipleCampaignsPopup,
    onCallAcceptHandler,
    onCallRejectHandler,
    focusAmeyoHandler
  } = props;
  const campaignId = useSelector((state: RootState) => state.humanReminder.campaignId);
  const isAmeyoErroneous = useSelector((state: RootState) => state.humanReminder.isAmeyoErronous);
  const reminderRefId = useSelector((state: RootState) => state.humanReminder.reminderRefId);
  return (
    <>
      {isAmeyoErroneous ? (
        <div className={styles.waitingScreenContainer}>
          <img className={styles.errorImage} src={image} alt="error" />
          <div className={styles.waitingScreenTitle}>
            <Typography className={styles.ameyoErroneousTextContainer} variant="h3">
              <AlertOutlineIcon color="#E92C2C" />
              <span>{ameyoErroneousCallWaitingScreenText.title}</span>
            </Typography>
            <Typography variant="p3">{ameyoErroneousCallWaitingScreenText.subHeading}</Typography>
          </div>
        </div>
      ) : (
        <div className={styles.waitingScreenContainer}>
          <WaitingScreenIcon />
          <div className={styles.waitingScreenTitle}>
            Please wait while we connect you with a customer...
          </div>
        </div>
      )}
      {showCallIncomingPopup ? (
        <div className={styles.centerPopupContainer}>
          <div className={styles.callIncomingPopup}>
            <div className={styles.callIncomingIcon}>
              <CallInComingPhoneIcon />
            </div>
            <div className={styles.heading}>A call is connected...</div>
            <div className={cx(styles.subheading, styles.autoAcceptContainer)}>
              <InfoIcon />
              Auto accepting call in{' '}
              <span className={styles.autoAcceptCountdownText}>
                <Countdown
                  startFrom={Number(window?.config?.HRC_CALL_AUTO_ACCEPT_TIMEOUT)}
                  onComplete={() => {
                    addClickstreamEvent(HRC_CLICKSTREAM[HRC_EVENTS.HRC_AUTO_ACCEPTED_CALL], {
                      currentCallStatus: ExtensionHandler.currentCallStatus(),
                      campaignId
                    });
                    onCallAcceptHandler();
                  }}
                />{' '}
                seconds
              </span>
            </div>
            <div className={styles.callActionButtonContainer}>
              <div
                className={styles.acceptButton}
                onClick={() => {
                  addClickstreamEvent(HRC_CLICKSTREAM[HRC_EVENTS.ACCEPT_BUTTON_CLICKED], {
                    currentCallStatus: ExtensionHandler.currentCallStatus(),
                    campaignId,
                    reminderRefId,
                    ametoStatus: ExtensionHandler.currentAmeyoStatus()
                  });
                  debounce(onCallAcceptHandler)();
                }}
              >
                <span>Accept</span>
              </div>
            </div>
          </div>
          <div className={styles.overlay}></div>
        </div>
      ) : null}
      {showAuthBlockedPopup ? (
        <div className={styles.centerPopupContainer}>
          <div className={styles.authBlockedPopup}>
            <div className={styles.authBlockedHeader}>
              <span className={styles.authBlockedHeaderIcon}>
                <ErrorIcon />
              </span>
              <p className={styles.authBlockedHeaderTitle}>Issue logging in to Ameyo</p>
            </div>
            <p className={styles.authBlockedContent}>
              Please go to Ameyo tab and manually log in using your username and password.
              <br />
              <br />
              Reach out to support, if needed.
            </p>
            <button className={styles.authBlockedGotoameyo} onClick={focusAmeyoHandler}>
              <span>Go to Ameyo</span>
            </button>
          </div>
          <div className={styles.overlay}></div>
        </div>
      ) : null}
      {showMultipleCampaignsPopup ? (
        <div className={styles.centerPopupContainer}>
          <div className={styles.authBlockedPopup}>
            <div className={styles.authBlockedHeader}>
              <span className={styles.authBlockedHeaderIcon}>
                <ErrorIcon />
              </span>
              <p className={styles.authBlockedHeaderTitle}>Multiple Campaigns Found</p>
            </div>
            <p className={styles.authBlockedContent}>
              Please go to Ameyo tab and manually select the campaign
              <br />
              <br />
              Reach out to support, if needed.
            </p>
            <button className={styles.authBlockedGotoameyo} onClick={focusAmeyoHandler}>
              <span>Go to Ameyo</span>
            </button>
          </div>
          <div className={styles.overlay}></div>
        </div>
      ) : null}
    </>
  );
};

export default CallWaitingScreen;
